import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { RippleModule } from 'primeng/ripple';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-elimina-intervento',
  templateUrl: './elimina-intervento.component.html',
  styleUrls: ['./elimina-intervento.component.css'],
  providers: [DialogService],
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    ToastModule,
    RippleModule
  ]
})
export class EliminaInterventoComponent {
  @Input() visible: boolean = false;
  @Input() intervento: any;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() onConfirm = new EventEmitter<void>();

  constructor() {}

  hide() {
    this.visibleChange.emit(false);
  }

  conferma() {
    this.onConfirm.emit();
    this.visibleChange.emit(false);
  }
}
